export default __webpack_public_path__ + "static/media/tokenDemandMb1.8a484bf5.png";